// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ResultsFeedService {
   $q: any
   $timeout: any
   alertService: AlertService
   appState: AppStateService
   availability: AvailabilityService
   data: any
   endOfResults: any
   events: EventService
   loadingFromCache: any
   noResults: any
   plugins: any[]
   position: any
   positionalItems: any
   resultsConfig: any
   scope: any
   showTop: any
   state: any
   maxPages: number
   constructor(data: DataService, plugins: ResultsFeedServicePlugins, appState: AppStateService, events: EventService, alertService: AlertService, availability: AvailabilityService, config: ConfigService, $timeout: any, $q: any) {

      this.items = this.items.bind(this)
      this.clear = this.clear.bind(this)
      this.processNew = this.processNew.bind(this)
      this.processUpdate = this.processUpdate.bind(this)
      this.update = this.update.bind(this)
      this.addPositionalItem = this.addPositionalItem.bind(this)
      this.addItem = this.addItem.bind(this)
      this.toggleItem = this.toggleItem.bind(this)
      this.extractAvailabilityId = this.extractAvailabilityId.bind(this)
      this.showItems = this.showItems.bind(this)
      this.setEndOfResults = this.setEndOfResults.bind(this)
      this.data = data
      this.appState = appState
      this.events = events
      this.alertService = alertService
      this.availability = availability
      this.$timeout = $timeout
      this.$q = $q
      this.clear()
      this.scope.loading = false
      this.maxPages = 200 // highest pn param that summon api can support https://wiki.clarivate.io/display/subsystem/CDI+Deep+Paging+Analysis

      // Overwrite in constructor
      this.noResults = true

      // service-related variables
      this.resultsConfig = config.data.results
      this.plugins = plugins.plugins

      // set up hooks on data service
      this.data.on('new', this.processNew)
      this.data.on('update', this.processUpdate)
   }

   items() {
      return this.scope.items
   }

   clear() {
      if (!this.scope) { this.scope = {} }
      const object = { items: [], removedHeight: 0, heightStack: [], hiddenItems: false }
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      for (var k in object) { var v = object[k]; this.scope[k] = v }
      this.noResults = false
      this.endOfResults = false
      this.positionalItems = {}
      this.state = 'new'

      // infinite-scroll-related variables
      this.position = 1
   }

   processNew(data: any) {
      if (data?.query?.page_number === 1) {
         this.clear()
      }
      this.update()
   }

   processUpdate() {
      this.state = 'update'
      return this.update()
   }

   update() {
      // don't process update if showTop flag is set mid-update
      if (this.showTop) {
         this.showTop = false
         return
      }

      return this.plugins.forEach((p: any) => {
         if (_(p.states).contains(this.state)) { return p.invoke(this.data.data, this) }
      })
   }

   addPositionalItem(item: any, pos: any) {
      if (!this.positionalItems[pos]) { this.positionalItems[pos] = [] }
      this.positionalItems[pos].push(item)
      if ((this.position === 1) && (pos === 1)) {
         return this.scope.items.push(item)
      }
   }

   addItem(item: any) {
      let posItems
      this.scope.items.push(item)
      this.position += 1
      if (posItems = this.positionalItems[this.position]) {
         return posItems.forEach((posItem: any) => this.scope.items.push(posItem))
      }
   }

   toggleItem(index: any, opts = { hiddenVal: true }) {
      const item = this.scope.items[index]
      if (item) { return item.hidden = opts.hiddenVal }
   }

   extractAvailabilityId(index: any, availabilityIds: any) {
      const item = this.scope.items[index]
      const id = item.document?.availability_id
      if (id != null) {
         return availabilityIds.push(id)
      }
   }

   showItems(start: any, end: any) {
      let index
      let asc, end1
      let asc1, end2
      for (index = start, end1 = end, asc = start <= end1; asc ? index < end1 : index > end1; asc ? index++ : index--) { this.toggleItem(index, { hiddenVal: false }) }
      const availabilityIds: any = []
      for (index = start, end2 = end, asc1 = start <= end2; asc1 ? index < end2 : index > end2; asc1 ? index++ : index--) { this.extractAvailabilityId(index, availabilityIds) }
      if (availabilityIds.length) {
         return this.$timeout((() => this.availability.updateAvailabilityFromCache(availabilityIds)), 250)
      }
   }

   goToTop() {
      window.scrollTo(0, 0)
   }

   loadPrev() {
      return this.loadPage(+this.appState.params.pn - 1)
   }

   loadNext() {
      return this.loadPage(+this.appState.params.pn + 1)
   }

   loadPage(pageNum: number) {
      let resolvedPromise: Promise<boolean>
      const showFirstItem = true
      this.hidePage(showFirstItem)
      this.position = ((pageNum - 1) * this.resultsConfig.pageSize) + 1
      if (this.isPageLoaded(pageNum)) {
         this.loadPageFromCache(pageNum)
         resolvedPromise = this.$q.resolve(true)
      } else {
         resolvedPromise = this.loadPageFromApi(pageNum)
      }
      this.goToTop()
      return resolvedPromise
   }

   isPageLoaded(pageNum: number) {
      const {
         pageSize
      } = this.resultsConfig
      return this.scope.items.find((item: any) => item.document?.index === ((pageNum - 1) * pageSize + 1))
   }

   loadPageFromCache(pageNum: number) {
      this.appState.updatePageInUrl(pageNum)
      let lastItemIndex = pageNum * this.resultsConfig.pageSize
      
      //CDI-29137 Fix for edge case when the last page has fewer than the expected number of items. For example, with 36 items 
      //and a page size of 40, the last page will contain only 36 items.
      if (this.scope.items[0].recordCount < lastItemIndex) {
         lastItemIndex = this.scope.items[0].recordCount
      }

      const start = this.scope.items.findIndex((item: any) => item.document?.index === (pageNum - 1) * this.resultsConfig.pageSize + 1)
      const end = this.scope.items.findIndex((item: any) => item.document?.index === lastItemIndex)
      this.showItems(start, end + 1)
   }

   loadPageFromApi(pageNum: number) {
      this.scope.loading = true
      this.appState.params.pn = pageNum
      this.events.publish("actions", "results:more", { page: pageNum })
      return this.appState.applyState({ isPageRequest: true })
   }

   hidePage(showFirstItem = false) {
      const length = this.scope.items.length
      for (let i = 0; i < length; i++) {
         this.toggleItem(i, { hiddenVal: true })
      }
      if (showFirstItem) {
         this.toggleItem(0, { hiddenVal: false })
      }
   }

   setEndOfResults(opts = { maxLimit: false }) {
      if (this.endOfResults) { return }
      if (opts.maxLimit) {
         // add a page num when hitting the max limit to be able to remove EoR
         // message when loading a previous page
         this.appState.params.pn += 1
      } else {
         // reset page num param to last valid page of results
         this.appState.params.pn -= 1
      }
      this.endOfResults = true
      const item = {
         endOfResults: true,
         type: 'noResults'
      }
      return this.addItem(item)
   }
}

ResultsFeedService.$inject = ['dataService', 'resultsFeedServicePlugins', 'appStateService', 'eventService', 'alertService', 'availabilityService', 'configService', '$timeout', '$q']

angular.module('summonApp.services')
   .service('resultsFeedService', ResultsFeedService)
